var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"squire-wrap",class:{
             'border-green': _vm.color === 'GREEN',
             'border-red': _vm.color === 'RED',
             'border-gray': _vm.color === 'GREY'
         }},[_c('div',{staticClass:"squire",class:{
                 'bg-green': _vm.color === 'GREEN',
                 'bg-red': _vm.color === 'RED',
                 'bg-gray': _vm.color === 'GREY'
             }})])])}
var staticRenderFns = []

export { render, staticRenderFns }